import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Alert } from 'components/patterns'

export const StyledTop = styled.div`
  display: flex;
  z-index: 2;
  margin-top: -30px;
  padding-top: 30px;
  padding-bottom: 30px;
  background: ${themeColor('whitePrimary')};
  > div:first-of-type {
    margin-right: 40px;
  }
`

export const DrawerTitle = styled.span`
  display: block;
  margin-top: 5px;
  padding: 0 18px;
  font-weight: bold;
`

export const HeaderBox = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
`

export const ScrollStack = styled.div`
  padding-bottom: 100px;
`

export const StyledAlert = styled(Alert)`
  width: 100%;
`

export const PtoTemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
